







import jQuery from 'jquery'
import UIkit from 'uikit'
import Icons from "uikit/dist/js/uikit-icons"

window.$ = window.jQuery = jQuery
window.UIkit = UIkit
UIkit.use Icons

export default 
    name: 'App',

    data: ->
        contentLoaded: false
        fields:
            start_page: null,
            default_header: null,
            default_footer: null

    methods:
        getContent: ->
            @$prismic.client.getSingle('settings').then (document) =>
                @fields.start_page = document.data.start_page
                @fields.default_header = document.data.default_header
                @fields.default_footer = document.data.default_footer
                @contentLoaded = true

    created: ->
        @getContent()
            
        
